import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { PowerIcon, ServerStackIcon } from '@heroicons/react/24/outline';
import { Route, Switch } from 'wouter';
import { useAuth } from './auth/useAuth';
import { Button } from './components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './components/ui/card';
import { HomePage } from './pages/HomePage';

function App() {
  const { accounts, handleLogin, handleLogout } = useAuth();

  return (
    <div className='min-h-screen'>
      <AuthenticatedTemplate>
        <header className='border-b bg-primary text-primary-foreground'>
          <div className='container mx-auto flex items-center gap-6 px-6 py-4'>
            <h1 className='text-xl font-semibold flex items-center gap-2'>
              <ServerStackIcon className='w-6 h-6' />
              <span>Version Watson</span>
              <span className='text-sm font-normal opacity-60'>
                {import.meta.env.VITE_APP_VERSION}
              </span>
            </h1>
            <nav className='flex flex-1 gap-6'></nav>
            <div className='flex items-center gap-4'>
              <span className='text-sm'>{accounts[0]?.username}</span>
              <Button variant='ghost' size='icon' onClick={handleLogout} title='Logout'>
                <PowerIcon className='h-5 w-5' />
              </Button>
            </div>
          </div>
        </header>

        <main className='container mx-auto p-6'>
          <Switch>
            <Route path='/' component={HomePage} />
          </Switch>
        </main>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <div className='flex min-h-screen items-center justify-center'>
          <Card className='w-full max-w-md'>
            <CardHeader className='text-center'>
              <CardTitle className='text-3xl'>Deployment Dashboard</CardTitle>
              <CardDescription>Please sign in to access the deployment dashboard</CardDescription>
            </CardHeader>
            <CardContent className='space-y-4'>
              <Button onClick={handleLogin} className='w-full' size='lg'>
                Sign In with Microsoft
              </Button>
            </CardContent>
          </Card>
        </div>
      </UnauthenticatedTemplate>
    </div>
  );
}

export default App;
